module.exports = __webpack_public_path__ + "img/common-search-criteria.1f915cd0.svg";